export const stickyNoteShare = {
    text: "Partagez ce post-it avec vos collègues :",
    title: "Partagez votre post-it avec {first-name} {last-name}"
}